var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667,12A2.667,2.667,0,1,1,12,9.333,2.667,2.667,0,0,1,14.667,12Zm3.846-3.232c.038.843.046,1.1.046,3.232s-.008,2.389-.046,3.233c-.1,2.15-1.109,3.181-3.279,3.279-.844.038-1.1.047-3.234.047s-2.39-.008-3.232-.046c-2.174-.1-3.181-1.132-3.279-3.279-.039-.845-.048-1.1-.048-3.234s.009-2.389.047-3.232c.1-2.152,1.109-3.181,3.279-3.279.844-.039,1.1-.047,3.233-.047s2.39.008,3.233.046c2.168.1,3.18,1.128,3.28,3.28ZM16.108,12A4.108,4.108,0,1,0,12,16.108,4.108,4.108,0,0,0,16.108,12ZM17.23,7.73a.96.96,0,1,0-.96.96.96.96,0,0,0,.96-.96ZM24,0V24H0V0ZM20,12c0-2.172-.009-2.445-.048-3.3-.131-2.9-1.745-4.52-4.653-4.653C14.445,4.009,14.173,4,12,4s-2.444.009-3.3.048C5.8,4.181,4.182,5.793,4.048,8.7,4.009,9.555,4,9.828,4,12s.009,2.445.048,3.3C4.182,18.2,5.794,19.819,8.7,19.952c.854.039,1.125.048,3.3.048s2.445-.009,3.3-.048c2.9-.133,4.522-1.745,4.653-4.654C19.991,14.445,20,14.173,20,12Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/insta-logo.ea37c572fe181d8b0d38eff00f22b015.svg";
export { ForwardRef as ReactComponent };